// The keys upstack_api's PermissionSets::Capabilities::MAP registers for custom-field writes, kept in step by hand.
export const CustomFieldCapability = {
  DEFINITIONS_CREATE: 'custom_field_definitions#create',
  DEFINITIONS_UPDATE: 'custom_field_definitions#update',
  DEFINITIONS_CHANGE_FIELD_TYPE: 'custom_field_definitions#change_field_type',
  VALUES_UPSERT: 'custom_field_values#upsert'
} as const;
